import * as CookieConsent from "vanilla-cookieconsent";
import { buildConfig } from "./config.js";

const ROOT_SELECTOR = "#cc-main";

async function boot() {
  if (document.querySelector(ROOT_SELECTOR)) return;

  CookieConsent.reset(false);
  await CookieConsent.run(buildConfig());
}

document.addEventListener("DOMContentLoaded", boot);
document.addEventListener("turbo:load", boot);

window.SfCookieConsent = {
  showPreferences: () => CookieConsent.showPreferences(),
  reset:           () => CookieConsent.reset(true),
};
